import { render, staticRenderFns } from "./landing-page.vue?vue&type=template&id=5d634bd4"
import script from "./landing-page.vue?vue&type=script&lang=js"
export * from "./landing-page.vue?vue&type=script&lang=js"
import style0 from "./landing-page.vue?vue&type=style&index=0&id=5d634bd4&prod&lang=scss&module=%24s"




function injectStyles (context) {
  
  this["$s"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports